import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Breadcrumbs,
  Link as MuiLink,
  Tabs,
  Tab,
  IconButton
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DatasetManagerTab from './tabs/DatasetManagerTab';
import TrainingControlTab from './tabs/TrainingControlTab';

// Tab Panel Helper Component
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`training-management-tabpanel-${index}`}
      aria-labelledby={`training-management-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `training-management-tab-${index}`,
    'aria-controls': `training-management-tabpanel-${index}`,
  };
}

const TrainingManagementView: React.FC = () => {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Breadcrumbs Navigation */}
      <Breadcrumbs aria-label="Navigationspfad" sx={{ mb: 2 }}>
        <MuiLink
          color="inherit"
          component="button"
          variant="body1"
          onClick={() => navigate('/dashboard')}
          sx={{ textDecoration: 'none', cursor: 'pointer' }}
        >
          Dashboard
        </MuiLink>
        <MuiLink
          color="inherit"
          component="button"
          variant="body1"
          onClick={() => navigate('/backoffice')}
          sx={{ textDecoration: 'none', cursor: 'pointer' }}
        >
          Administration
        </MuiLink>
        <Typography color="text.primary">Training Management</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            sx={{ mr: 2 }}
            onClick={() => navigate('/backoffice')}
            aria-label="Zurück zur Administration"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1">
            Training Management
          </Typography>
        </Box>
      </Box>

      {/* Tabs */}
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="Training Management Tabs">
          <Tab label="Training Steuerung" {...a11yProps(0)} />
          <Tab label="Datensätze" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <TabPanel value={tabValue} index={0}>
        <TrainingControlTab />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <DatasetManagerTab />
      </TabPanel>

    </Container>
  );
};

export default TrainingManagementView; 